export default __webpack_public_path__ + "static/media/not-found.72d5e83f.PNG";